"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _TrafficSpacesRowStyles = require("../../styles/TrafficSpacesRowStyles");

var _OrbitNetLabels = _interopRequireDefault(require("../Labels/OrbitNetLabels"));

var _TrafficAppointmentCard = _interopRequireDefault(require("./TrafficAppointmentCard"));

var _TrafficAppointmentConflicCard = _interopRequireDefault(require("./TrafficAppointmentConflicCard"));

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TrafficSpaceRowFixed = /*#__PURE__*/function (_React$Component) {
  _inherits(TrafficSpaceRowFixed, _React$Component);

  var _super = _createSuper(TrafficSpaceRowFixed);

  function TrafficSpaceRowFixed() {
    var _this;

    _classCallCheck(this, TrafficSpaceRowFixed);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      spaces: []
    });

    _defineProperty(_assertThisInitialized(_this), "spaceWidth", 100);

    _defineProperty(_assertThisInitialized(_this), "diffRanges", _this.props.range[1] - _this.props.range[0]);

    _defineProperty(_assertThisInitialized(_this), "totalAvailableSpaces", (_this.diffRanges + _this.spaceWidth) / _this.spaceWidth);

    _defineProperty(_assertThisInitialized(_this), "widthSpaces", _this.spaceWidth / _this.totalAvailableSpaces - 0);

    _defineProperty(_assertThisInitialized(_this), "getCards", function () {
      var _winds$;

      var _this$props = _this.props,
          range = _this$props.range,
          windows = _this$props.windows,
          appointments = _this$props.appointments,
          conflicts = _this$props.conflicts;

      var winds = _toConsumableArray(windows);

      var appoints = _toConsumableArray(appointments);

      var conflict = _toConsumableArray(conflicts);

      appoints = appoints.concat(conflicts);
      var result = [];
      winds.sort(function (a, b) {
        return a.begin - b.begin;
      });
      appoints.sort(function (a, b) {
        return a.begin - b.begin;
      });
      conflict.sort(function (a, b) {
        return a.begin - b.begin;
      });
      result = result.concat(_this.getClosedCards(range[0], ((_winds$ = winds[0]) === null || _winds$ === void 0 ? void 0 : _winds$.begin) >= 0 ? winds[0].begin : range[1] + 100));
      winds.forEach(function (wnd, index) {
        var windowAppoints = appoints.filter(function (ap) {
          return ap.begin >= wnd.begin && ap.end <= wnd.end;
        });

        if (windowAppoints.length) {
          windowAppoints.forEach(function (app, indexWa, source) {
            if (indexWa === 0) {
              result = result.concat(_this.getFreeCards(wnd.begin, app.begin, wnd));
            }

            result = result.concat(_this.getAppointmentCard(app));
            result = result.concat(_this.getFreeCards(app.end, source[indexWa + 1] ? source[indexWa + 1].begin : wnd.end, wnd));
          });
        } else {
          result = result.concat(_this.getFreeCards(wnd.begin, wnd.end, wnd));
        }

        if (wnd.end <= range[1]) {
          var _winds;

          result = result.concat(_this.getClosedCards(wnd.end, ((_winds = winds[index + 1]) === null || _winds === void 0 ? void 0 : _winds.begin) || range[1] + 100));
        }
      }); // if (winds.pop()?.end <= range[1]) {
      //   result.push({
      //     close: true,
      //     margin: '0 0.2rem 0 0',
      //     width: `${this.widthSpaces}%`,
      //     end: range[1] + this.spaceWidth
      //   })
      // }

      return result;
    });

    _defineProperty(_assertThisInitialized(_this), "getClosedCards", function (begin, end) {
      // debugger;
      var beginFreeSpaces = Math.abs(begin - end) / _this.spaceWidth;

      var result = [];
      var initialFraction = 1 - begin % _this.spaceWidth / 100;
      var endingFraction = end % _this.spaceWidth / 100;

      if (initialFraction < 1) {
        result.push({
          close: true,
          margin: '0 0.2rem 0 0',
          width: "".concat(_this.widthSpaces * initialFraction, "%")
        });
      }

      for (var space = 1; space <= beginFreeSpaces; space++) {
        result.push({
          close: true,
          margin: '0 0.2rem 0 0',
          width: "".concat(_this.widthSpaces, "%")
        });
      }

      if (endingFraction < 1) {
        result.push({
          close: true,
          margin: '0 0.2rem 0 0',
          width: "".concat(_this.widthSpaces * endingFraction, "%")
        });
      } // debugger;


      return result.filter(function (r) {
        return r.width !== '0%';
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getPorcentage", function (position, total) {
      return position * 100 / total;
    });

    _defineProperty(_assertThisInitialized(_this), "getPosition", function (appointment, begin, end) {
      var totalPx = appointment.end - appointment.begin;
      var childBegin = begin - appointment.begin;
      var childEnd = appointment.end - end;
      return {
        begin: String(_this.getPorcentage(childBegin, totalPx)).concat('%'),
        end: String(_this.getPorcentage(childEnd, totalPx)).concat('%')
      };
    });

    _defineProperty(_assertThisInitialized(_this), "setTimetoPercent", function (value) {
      return parseInt(value / 100) * 100 + Math.min(value % 100, 59) * 100 / 60;
    });

    _defineProperty(_assertThisInitialized(_this), "getAppointmentCard", function (appointment) {
      var result = [];
      var appointBegin = appointment.begin; // const appointBegin = convertTimeToWidthSpace(appointment.begin)

      var appointEnd = appointment.end; // const appointEnd = convertTimeToWidthSpace(appointment.end)

      var spaceAppointment = appointEnd - appointBegin;

      var width = _this.calculateWidthSpace(spaceAppointment);

      var orders = [];

      if (appointment.orders) {
        appointment.orders.forEach(function (order) {
          var _this$getPosition = _this.getPosition(appointment, _this.setTimetoPercent(order.begin), _this.setTimetoPercent(order.end)),
              begin = _this$getPosition.begin,
              end = _this$getPosition.end;

          orders.push(_objectSpread(_objectSpread({}, order), {}, {
            begin: begin,
            end: end
          }));
        });
      }

      result.push(_objectSpread(_objectSpread({}, appointment), {}, {
        orders: orders,
        height: '100%',
        width: width,
        //   begin: appointBegin,
        //   end: appointEnd,
        margin: '0 0.2rem 0 0',
        borderRadius: appointEnd % _this.spaceWidth !== 0 && '0.2rem',
        borderRight: appointEnd % _this.spaceWidth !== 0 && '1px gray solid'
      }));
      return result;
    });

    _defineProperty(_assertThisInitialized(_this), "getFreeCards", function (begin, end, wnd) {
      // debugger;
      if (begin === end) return [];
      var result = [];
      var freeSpace = (end - begin) / _this.spaceWidth;
      var initialFraction = 1 - begin % _this.spaceWidth / 100;
      var endingFraction = end % _this.spaceWidth / 100;

      if (freeSpace < 1) {
        result.push({
          x: '1',
          free: true,
          width: "".concat(_this.widthSpaces * freeSpace, "%"),
          begin: begin,
          margin: '0',
          unused: _this.validateCardWithCurrentTime(begin),
          dropOnWindow: wnd.dropOnWindow
        });
        return result;
      }

      if (initialFraction > 0 && initialFraction < 1) {
        result.push({
          x: '2',
          free: true,
          width: "".concat(_this.widthSpaces * initialFraction, "%"),
          begin: begin,
          end: begin + initialFraction * 100,
          margin: '0',
          unused: _this.validateCardWithCurrentTime(begin),
          dropOnWindow: wnd.dropOnWindow
        });
        freeSpace -= initialFraction;
      }

      var lastSpaceEnd = 0;
      freeSpace += .00000000001; //let space = initialFraction < 1 ? 1 : 0;

      for (var space = initialFraction < 1 ? 1 : 0; freeSpace-- >= 1; space++) {
        lastSpaceEnd = begin + initialFraction * 100 + _this.spaceWidth * space;
        result.push({
          x: '3',
          free: true,
          width: "".concat(_this.widthSpaces, "%"),
          begin: lastSpaceEnd - _this.spaceWidth,
          end: lastSpaceEnd,
          margin: lastSpaceEnd % _this.spaceWidth === 0 ? '0 0.2rem 0 0' : '0',
          unused: _this.validateCardWithCurrentTime(lastSpaceEnd),
          dropOnWindow: wnd.dropOnWindow
        });
      }

      if (freeSpace && endingFraction) {
        result.push({
          x: '4',
          free: true,
          width: "".concat(_this.widthSpaces * endingFraction, "%"),
          begin: end - _this.spaceWidth * endingFraction,
          end: end,
          margin: '0 0.2rem 0 0',
          unused: _this.validateCardWithCurrentTime(end),
          dropOnWindow: wnd.dropOnWindow
        });
      } // debugger;


      return result;
    });

    _defineProperty(_assertThisInitialized(_this), "validateCardWithCurrentTime", function (spaceEnd) {
      return spaceEnd / _this.spaceWidth <= new Date().getHours() && _this.props.dateValidation <= 0;
    });

    _defineProperty(_assertThisInitialized(_this), "calculateWidthSpace", function (appointmentInterval) {
      return "".concat(_this.widthSpaces * appointmentInterval / _this.spaceWidth, "%");
    });

    return _this;
  }

  _createClass(TrafficSpaceRowFixed, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          className = _this$props2.className,
          rowIndex = _this$props2.rowIndex,
          loadManeuver = _this$props2.loadManeuver,
          loadManeuverIcon = _this$props2.loadManeuverIcon,
          unloadManeuver = _this$props2.unloadManeuver,
          unloadManeuverIcon = _this$props2.unloadManeuverIcon,
          unloadLoadManeuver = _this$props2.unloadLoadManeuver,
          unloadLoadManeuverIcon = _this$props2.unloadLoadManeuverIcon,
          tags = _this$props2.tags,
          spaceIndex = _this$props2.spaceIndex;
      return /*#__PURE__*/_react["default"].createElement(_TrafficSpacesRowStyles.Wrapper, _extends({
        className: className
      }, this.props), /*#__PURE__*/_react["default"].createElement(_TrafficSpacesRowStyles.LabelColumn, null, /*#__PURE__*/_react["default"].createElement(_TrafficSpacesRowStyles.CounterWrapper, null, spaceIndex), /*#__PURE__*/_react["default"].createElement(_TrafficSpacesRowStyles.LabelWrapper, null, /*#__PURE__*/_react["default"].createElement(_TrafficSpacesRowStyles.ManouverWrapper, null, loadManeuver && loadManeuverIcon, unloadManeuver && unloadManeuverIcon, unloadLoadManeuver && unloadLoadManeuverIcon), /*#__PURE__*/_react["default"].createElement(_OrbitNetLabels["default"], {
        type: "multiple",
        textColor: "#436EA9",
        labels: tags,
        rowIndex: rowIndex
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "scroll-test-traffic-row",
        style: {
          width: '85%',
          overflow: 'hidden',
          zIndex: '9'
        }
      }, /*#__PURE__*/_react["default"].createElement(_TrafficSpacesRowStyles.SpaceWrapper, null, this.getCards().map(function (space, i) {
        return space.isConflict ?
        /*#__PURE__*/
        // eslint-disable-next-line react/no-array-index-key
        _react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_TrafficAppointmentConflicCard["default"], _extends({
          spaceId: _this2.props.id
        }, space, {
          key: i,
          spaceIndex: spaceIndex
        }))) :
        /*#__PURE__*/
        // eslint-disable-next-line react/no-array-index-key
        _react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_TrafficAppointmentCard["default"], _extends({
          dateValidation: _this2.props.dateValidation
        }, space, {
          key: i,
          spaceId: _this2.props.id,
          spaceIndex: spaceIndex
        })));
      }))));
    }
  }]);

  return TrafficSpaceRowFixed;
}(_react["default"].Component);

var _default = TrafficSpaceRowFixed;
exports["default"] = _default;
TrafficSpaceRowFixed.defaultProps = {
  id: null,
  loadManeuver: false,
  unloadManeuver: false,
  unloadLoadManeuver: false,
  loadManeuverIcon: null,
  unloadManeuverIcon: null,
  unloadLoadManeuverIcon: null,
  range: [600, 1900],
  available: true,
  className: null,
  tags: [],
  appointments: [],
  conflicts: []
};